import { z } from 'zod';
import { DynamicBaseDTO } from './DynamicBaseDTO';

export const DynamicIconDTO = DynamicBaseDTO.extend({
    iconName: z.string(),
});

export type DynamicIconDTO = z.infer<typeof DynamicIconDTO>;
